import React from "react";

const Welcome = () => {
  return (
    <main className="flex flex-col h-[calc(100vh-60px)] justify-center items-center">
      <h1 className="text-5xl mb-6">Welcome to Corex Cockpit</h1>
      <p className="text-xl">To access the website please sign in</p>
    </main>
  );
};

export default Welcome;
